export default __webpack_public_path__ + "static/media/Nodata.27fea020.png";